<template>
  <div v-if="loading" class="text-center mt-5 font-2xl text-muted">
    <i class="fal fa-spinner fa-spin" /> Test Task Data Loading...
  </div>
  <div v-else class="animated fadeIn">
    <basic-heading
      :title="`${test_process.name}: ${test_task.name}`"
      class="mb-3"
    >
      <template #right-content>
        <header-button-group :button_config="button_config">
          <template #post_buttons>
            <button
              v-show="checkPermission('delete test task')"
              title="Delete task"
              class="btn btn-danger ml-1"
              @click="showDeleteModal"
            >
              <i class="fal fa-trash" />
            </button>
          </template>
        </header-button-group>
      </template>
    </basic-heading>
    <b-row>
      <b-col class="pr-0">
        <test-task-card :test_task="test_task" />
      </b-col>
      <b-col v-if="links.length">
        <link-tile
          v-for="(link, linkIndex) in links"
          :key="linkIndex"
          icon-cols="2"
          :to="link.to"
          :fa-icon="link.faIcon"
          :variant="link.variant"
          :text="link.text"
        />
      </b-col>
    </b-row>
    <test-task-detail-cardstack :test_task="test_task" />
  </div>
</template>

<script>
import Vue from "vue";
import VueNotifications from "vue-notifications";
import BasicHeading from "@/components/shared/BasicHeading";
import HeaderButtonGroup from "@/components/shared/headerbuttons/HeaderButtonGroup";
import LinkTile from "@/components/shared/LinkTile";
import TestTaskCard from "@/components/lab/testtask/TestTaskCard";
import TestTaskDetailCardstack from "@/components/lab/testtask/TestTaskDetailCardstack";
import { AccessControlCheck } from "@/auth/AccessControlCheck"
import { getModel } from "@/shared/fetch-utils";
import { LabRepositoryFactory } from "@/repositories/lab/LabRepositoryFactory";
import { notificationOptions } from "@/shared/toast-notification-options";
import { testTaskNotifications } from "@/shared/notifications";

const TestTaskRepository = LabRepositoryFactory.get("testTask");

Vue.use(VueNotifications, notificationOptions);

export default {
  name: "TestTaskDetail",
  components: {
    BasicHeading,
    HeaderButtonGroup,
    LinkTile,
    TestTaskCard,
    TestTaskDetailCardstack
  },
  data() {
    return {
      loading: true,
      test_task_id: this.$route.params.test_task_id || null,
      test_task: null,
      test_process: null,
      links: []
    };
  },
  computed: {
    button_config() {
      return {
        buttons: [
          {
            icon: "fa-list",
            linkto: `/test-processes/${this.test_process.id}`,
            title: "Test Task list"
          },
          {
            icon: "fa-pencil",
            linkto: `/test-tasks/${this.test_task_id}/edit`,
            title: "Edit Test Task",
            variant: "warning",
            permission: this.checkPermission('edit test task')
          }
        ]
      };
    }
  },
  methods: {
    checkPermission(permission) {
      return AccessControlCheck.checkPermission(permission);
    },
    async init() {
      const payload = {
        message: this.$bvToast
      };

      this.test_task = await getModel({
        ...payload,
        model_type: "test_task",
        id: this.test_task_id
      });
      this.test_process = await getModel({
        ...payload,
        model_type: "test_process",
        id: this.test_task.test_process_id
      });

      this.links = [
        ...this.links,
        {
          to: `/test-processes/${this.test_process.id}`,
          faIcon: this.test_process.icon(),
          variant: "dark",
          text: this.test_process.name
        }
      ];
      this.loading = false;
    },
    async deleteTask() {
      try {
        await TestTaskRepository.suspend(this.test_task_id);

        this.deleteSuccess();

        this.$router.push(`/test-processes/${this.test_process.id}`);
      } catch ({ response }) {
        this.$bvToast.toast(response.data.error, {
          title: "Task delete Failed.",
          variant: "danger"
        });
      }
    },
    showDeleteModal() {
      this.$bvModal
        .msgBoxConfirm(
          "You are about to remove this test task. Do you want to continue?",
          {
            title: "Are you sure?",
            modalClass: ["modal-danger"],
            size: "sm",
            okVariant: "danger",
            okTitle: "YES",
            cancelTitle: "NO",
            footerClass: "p-2",
            centered: true
          }
        )
        .then((confirm) => {
          if (confirm) {
            this.deleteTask();
          }
        });
    }
  },
  created() {
    this.loading = true;

    this.init();
  },
  notifications: testTaskNotifications
};
</script>
